import React from 'react';
import { Formik, Form, Field, CccisdSelect } from 'cccisd-formik';

import DragDropFields from './fields/DragDrop';
import HtmlFields from './fields/Html';
import VariableFields from './fields/Variable';
import style from './style.css';

const WidgetForm = ({ form: reportForm, closeModal, initialWidget }) => {
    const handleSubmit = localFormValues => {
        const newWidget = { type: localFormValues.type };

        // each widget needs unique identifier for drag-n-drop
        newWidget.id = initialWidget
            ? initialWidget.id
            : reportForm.values.widgetList.reduce((max, curr) => (max.id > curr.id ? max : curr), {
                  id: 0,
              }).id + 1;

        switch (localFormValues.type) {
            case 'dragdrop':
                newWidget.typeText = 'Drag & Drop';
                newWidget.assignmentId = localFormValues.assignmentId;
                newWidget.surveyId = localFormValues.surveyId;
                newWidget.dragDrop = localFormValues.dragDrop;
                newWidget.dragDropEntityId = localFormValues.dragDropEntityId;
                newWidget.questionText = localFormValues.questionText;
                break;
            case 'html':
                newWidget.typeText = 'HTML';
                newWidget.htmlContent = localFormValues.htmlContent;
                break;
            case 'pageBreak':
                newWidget.typeText = '-- Page Break --';
                break;
            case 'variable':
                newWidget.typeText = 'Variable';
                newWidget.assignmentId = localFormValues.assignmentId;
                newWidget.surveyId = localFormValues.surveyId;
                newWidget.variableId = localFormValues.variableId;
                newWidget.variable = localFormValues.variable;
                newWidget.questionText = localFormValues.questionText;
                break;
            default:
                break;
        }

        if (initialWidget) {
            const updatedList = [...reportForm.values.widgetList];
            const editIndex = updatedList.findIndex(w => w.id === initialWidget.id);
            updatedList[editIndex] = newWidget;
            reportForm.setFieldValue('widgetList', updatedList);
        } else {
            reportForm.setFieldValue('widgetList', [...reportForm.values.widgetList, newWidget]);
        }

        closeModal();
    };

    const validate = values => {
        let errors = {};

        switch (values.type) {
            case 'dragdrop':
                if (!values.assignmentId) {
                    errors.assignmentId = 'Required';
                }
                if (!values.surveyId) {
                    errors.surveyId = 'Required';
                }
                if (!values.dragDropEntityId || !values.dragDrop) {
                    errors.dragDropEntityId = 'Required';
                }
                break;
            case 'html':
                if (!values.htmlContent) {
                    errors.htmlContent = 'Required';
                }
                break;
            case 'pageBreak':
                break;
            case 'variable':
                if (!values.assignmentId) {
                    errors.assignmentId = 'Required';
                }
                if (!values.surveyId) {
                    errors.surveyId = 'Required';
                }
                if (!values.variableId) {
                    errors.variableId = 'Required';
                }
                break;
            default:
                errors.type = 'Required';
        }

        return errors;
    };

    const intialValues = {
        type: initialWidget?.type || 'variable',
        assignmentId: initialWidget?.assignmentId || '',
        surveyId: initialWidget?.surveyId || '',
        variableId: initialWidget?.variableId || '',
        variable: initialWidget?.variable || {},
        dragDropEntityId: initialWidget?.dragDropEntityId || '',
        dragDrop: initialWidget?.dragDrop || {},
        questionText: initialWidget?.questionText || '',
        htmlContent: initialWidget?.htmlContent || '',
    };

    return (
        <Formik initialValues={intialValues} onSubmit={handleSubmit} validate={validate}>
            {localForm => (
                <Form>
                    <Field name="type">
                        {fieldProps => (
                            <CccisdSelect
                                {...fieldProps}
                                label="Type"
                                options={[
                                    { value: 'dragdrop', label: 'Drag & Drop' },
                                    { value: 'html', label: 'HTML' },
                                    { value: 'pageBreak', label: 'Page Break' },
                                    { value: 'variable', label: 'Variable' },
                                ]}
                                onChange={event => {
                                    localForm.setFieldValue('type', event.currentTarget.value);
                                    localForm.setFieldValue('assignmentId', '');
                                }}
                            />
                        )}
                    </Field>

                    {localForm.values.type === 'variable' && (
                        <VariableFields localForm={localForm} initialWidget={initialWidget} />
                    )}
                    {localForm.values.type === 'dragdrop' && (
                        <DragDropFields localForm={localForm} initialWidget={initialWidget} />
                    )}
                    {localForm.values.type === 'html' && <HtmlFields />}

                    <div className={style.btnContainer}>
                        <button type="button" className="btn btn-default" onClick={() => closeModal()}>
                            Cancel
                        </button>
                        <button type="button" className="btn btn-primary" onClick={localForm.submitForm}>
                            {initialWidget ? 'Save' : 'Add Widget'}
                        </button>
                    </div>
                </Form>
            )}
        </Formik>
    );
};

export default WidgetForm;
